import React, { useState, useRef, useEffect } from "react";
interface ToggleSwitchProps {
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	leftText: string;
	rightText: string;
	height?: number;
}
const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
	checked,
	onChange,
	leftText,
	rightText,
	height = 30,
}: ToggleSwitchProps) => {
	const [width, setWidth] = useState(150);
	const leftSpanRef = useRef<HTMLSpanElement>(null);
	const rightSpanRef = useRef<HTMLSpanElement>(null);
	useEffect(() => {
		if (leftSpanRef.current && rightSpanRef.current) {
			const leftWidth = leftSpanRef.current.offsetWidth;
			const rightWidth = rightSpanRef.current.offsetWidth;
			setWidth(leftWidth + rightWidth + 4); // Adding some padding
		}
	}, [leftText, rightText]);
	return (
		<div className="flex items-center gap-x-2">
			<div className="execution-level-wrapper">
				<div className="execution-level-title">View By</div>
			</div>
			<div className="relative inline-block" style={{ width, height }}>
				<input
					type="checkbox"
					id="toggle"
					className="absolute opacity-0 w-0 h-0"
					checked={checked}
					onChange={onChange}
				/>
				<label
					htmlFor="toggle"
					className="block overflow-hidden h-full rounded bg-[#f5f5f5] cursor-pointer relative border border-gray-400"
					style={{ width: width, height: height }}
				>
					<div className="flex h-full w-full">
						<div className="flex items-center justify-center relative z-10 min-w-0">
							<span
								ref={leftSpanRef}
								className={
									checked
										? "text-[#667085] text-[1.8vh] whitespace-nowrap px-2"
										: "text-black font-[500] text-[1.8vh] whitespace-nowrap px-2"
								}
							>
								{leftText}
							</span>
						</div>
						<div className="flex items-center justify-center relative z-10 min-w-0">
							<span
								ref={rightSpanRef}
								className={
									checked
										? "text-black font-[500] text-[1.8vh] whitespace-nowrap px-2"
										: "text-[#667085] text-[1.8vh] whitespace-nowrap px-2"
								}
							>
								{rightText}
							</span>
						</div>
					</div>
					<div
						className={`absolute top-0 h-full w-1/2 bg-white shadow-md transform transition-transform duration-300 ease-in-out ${
							checked ? "translate-x-full" : "translate-x-0"
						}`}
						style={{ height: height }}
					></div>
				</label>
			</div>
		</div>
	);
};
export default ToggleSwitch;
